import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function CouncilBluffsProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Council Bluffs"
      headingExtra="IA"
      introText="Council Bluffs and Omaha metro travelers — casino and hospitality professionals, Midlands University students, Pottawattamie County families, Union Pacific Railroad employees, and Southwest Iowa residents — have several options for getting a passport fast. Here is how they compare, and why most Council Bluffs residents choose a registered U.S. Department of State courier for fast, predictable processing."
      options={options}
      emergencyDescription="Strictly for documented life-or-death emergencies. You must obtain an appointment in advance — no walk-ins permitted. Nearest agency: Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 (~460 miles via I-80, 7+ hours). The Omaha-Council Bluffs metro sits in a multi-state dead zone — Nebraska, Iowa, Kansas, and South Dakota collectively have zero passport agencies. Winter highway conditions on I-80 can make emergency ground travel unreliable from December through March."
      disclaimerText="*Processing speed depends on eligibility and documentation. Regional Agency Processing requires life-or-death emergency documentation. Nearest passport agency: Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 (~460 miles via I-80). Nebraska, Iowa, Kansas, and South Dakota have zero passport agencies."
    />
  );
}